import { SaveButton } from 'components/Common/Button/SaveButton'
import ShowToRole from 'components/Common/Portal/ShowToRole'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import {
  IssueCode,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { SolveIssueAsync } from '../store/asyncActions/SolveIssueAsync'
import { projectOperationSelector } from '../store/selectors/projectOperationPendingSelector'
import { useNotAllowedWorkingStep } from './useNotAllowedWorkingStep'

type Props = {
  bomItemId: string
  workingStepType?: WorkingStepType
}

export const SolveWorkingStepNotAvailableButton = ({
  bomItemId,
  workingStepType,
}: Props) => {
  const dispatch = useAppDispatch()
  const operation = useAppSelector(
    projectOperationSelector(SolveIssueAsync.typePrefix.concat('/', bomItemId))
  )

  const { anyNotAllowedWorkingStep } = useNotAllowedWorkingStep(
    bomItemId,
    workingStepType
  )

  if (!anyNotAllowedWorkingStep) {
    return null
  }

  const handleSolveIssue = () => {
    dispatch(
      SolveIssueAsync({
        bomItemId,
        issueCode: IssueCode.WorkingStepNotAvailable,
      })
    )
  }

  return (
    <ShowToRole seller>
      <SaveButton
        variant="text"
        color="secondary"
        onClick={handleSolveIssue}
        saving={operation?.requestStatus === 'pending'}
        translationKey="project:solve-not-available-working-step"
      />
    </ShowToRole>
  )
}
